// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

const API_URL =
  "https://backend." + Properties.DOMAIN_URL + "/merchant-api/api/promo-merchants";

export default class PromoMerchantAPIService {
  constructor() { }
  config = this.$session.get("jwt");

  static getList = (limit, page, body) => {
    return apiClient.get(API_URL + "/limit/" + limit + "?page=" + page, {
      params: body,
    });
  };

  static edit = (id, kontrak) =>
    apiClient.post(API_URL + "/" + id, kontrak, {
    });

  static create = (kontrak) =>
    apiClient.post(API_URL + "/", kontrak, {
    });

  static delete = (kode, nik) =>
    apiClient.delete(API_URL + "/" + kode, {
      params: {
        user_update: nik,
      },
    });
}
